(() => {
  let generatedId = 0;
  let observerTimer;

  function bindOtherField(selectPrefix, inputPrefix) {
    document.querySelectorAll(`select[id^="${selectPrefix}"]`).forEach((select) => {
      if (select.dataset.rastbodenOtherBound === 'true') return;

      const suffix = select.id.slice(selectPrefix.length);
      const input = document.getElementById(`${inputPrefix}${suffix}`);
      if (!input) return;

      const label = document.querySelector(`label[for="${input.id}"]`);

      const sync = () => {
        const active = select.value === 'Annan';
        input.hidden = !active;
        input.required = active;
        input.setAttribute('aria-required', active ? 'true' : 'false');
        if (label) label.hidden = !active;
        if (!active) input.value = '';
      };

      select.dataset.rastbodenOtherBound = 'true';
      select.addEventListener('change', sync);
      sync();
    });
  }

  function productHandle(component) {
    const raw = component.dataset.productUrl || '';
    if (!raw) return '';

    try {
      const pathname = new URL(raw, window.location.origin).pathname;
      const match = pathname.match(/\/products\/([^/?#]+)/);
      return match ? match[1] : '';
    } catch (_) {
      return '';
    }
  }

  function confirmation(id, propertyName, label) {
    return `
      <div class="rastboden-personalization__confirm">
        <input id="${id}" type="checkbox" name="properties[${propertyName}]" value="Ja" required aria-required="true">
        <label for="${id}">${label} *</label>
      </div>`;
  }

  function legalText() {
    return `<p class="rastboden-personalization__legal"><strong>Personligt tillverkad produkt:</strong> Kontrollera uppgifterna noga. Produkten tillverkas efter dina val och omfattas normalt inte av ångerrätt. Reklamationsrätten påverkas inte.</p>`;
  }

  function valfriTextMarkup(suffix) {
    const textId = `rastboden-custom-text-${suffix}`;
    const confirmId = `rastboden-custom-text-confirm-${suffix}`;

    return `
      <div class="rastboden-personalization" data-rastboden-generated="valfri-text">
        <p class="rastboden-personalization__title">GÖR DEN PERSONLIG</p>
        <p class="rastboden-personalization__intro">Skriv texten exakt som du vill att den ska stå på båda dekalerna.</p>

        <label for="${textId}">Text på dekalen *</label>
        <input id="${textId}" type="text" name="properties[Text på dekalen]" maxlength="30" placeholder="Ex. GRÄVARN" autocomplete="off" required aria-required="true">
        <span class="rastboden-personalization__hint">Max 30 tecken. Smeknamn, företagsnamn, maskinnamn eller annan kort text.</span>

        ${confirmation(confirmId, 'Text kontrollerad', 'Jag har kontrollerat att texten är rätt.')}
        ${legalText()}
      </div>`;
  }

  function contactMarkup(suffix) {
    const typeId = `rastboden-contact-type-${suffix}`;
    const phoneId = `rastboden-phone-${suffix}`;
    const webId = `rastboden-web-${suffix}`;
    const otherId = `rastboden-other-contact-${suffix}`;
    const confirmId = `rastboden-contact-confirm-${suffix}`;

    return `
      <div class="rastboden-personalization" data-rastboden-generated="contact">
        <p class="rastboden-personalization__title">GÖR DEN PERSONLIG</p>
        <p class="rastboden-personalization__intro">Välj vad som ska stå på dekalen och fyll i uppgifterna exakt som du vill ha dem.</p>

        <label for="${typeId}">Vad ska stå på dekalen? *</label>
        <select id="${typeId}" name="properties[Typ av kontaktuppgift]" data-rastboden-contact-select required aria-required="true">
          <option value="" selected disabled>Välj typ</option>
          <option value="Telefonnummer">Telefonnummer</option>
          <option value="Webbadress">Webbadress</option>
          <option value="Telefon + webbadress">Telefon + webbadress</option>
          <option value="Annan kontakttext">Annan kontakttext</option>
        </select>

        <div class="rastboden-personalization__field-group" data-rastboden-phone hidden>
          <label for="${phoneId}">Telefonnummer *</label>
          <input id="${phoneId}" type="text" name="properties[Telefonnummer]" maxlength="30" placeholder="Ex. 070-123 45 67" autocomplete="tel">
        </div>

        <div class="rastboden-personalization__field-group" data-rastboden-web hidden>
          <label for="${webId}">Webbadress *</label>
          <input id="${webId}" type="text" name="properties[Webbadress]" maxlength="80" placeholder="Ex. rastboden.se" autocomplete="url">
        </div>

        <div class="rastboden-personalization__field-group" data-rastboden-other-contact hidden>
          <label for="${otherId}">Kontakttext *</label>
          <input id="${otherId}" type="text" name="properties[Annan kontakttext]" maxlength="60" placeholder="Skriv texten som ska stå på dekalen" autocomplete="off">
          <span class="rastboden-personalization__hint">Max 60 tecken.</span>
        </div>

        ${confirmation(confirmId, 'Kontaktuppgifter kontrollerade', 'Jag har kontrollerat att kontaktuppgifterna är rätt.')}
        ${legalText()}
      </div>`;
  }

  function bindContact(box) {
    if (!box || box.dataset.rastbodenContactBound === 'true') return;

    const select = box.querySelector('[data-rastboden-contact-select]');
    const phoneWrap = box.querySelector('[data-rastboden-phone]');
    const webWrap = box.querySelector('[data-rastboden-web]');
    const otherWrap = box.querySelector('[data-rastboden-other-contact]');
    const phone = phoneWrap?.querySelector('input');
    const web = webWrap?.querySelector('input');
    const other = otherWrap?.querySelector('input');
    if (!select) return;

    const setField = (wrap, input, active) => {
      if (!wrap || !input) return;
      wrap.hidden = !active;
      input.required = active;
      input.setAttribute('aria-required', active ? 'true' : 'false');
      if (!active) input.value = '';
    };

    const sync = () => {
      const value = select.value;
      setField(phoneWrap, phone, value === 'Telefonnummer' || value === 'Telefon + webbadress');
      setField(webWrap, web, value === 'Webbadress' || value === 'Telefon + webbadress');
      setField(otherWrap, other, value === 'Annan kontakttext');
    };

    box.dataset.rastbodenContactBound = 'true';
    select.addEventListener('change', sync);
    sync();
  }

  function injectNewPersonalization() {
    document.querySelectorAll('product-form-component[data-product-url]').forEach((component) => {
      const handle = productHandle(component);
      if (handle !== 'valfri-text-2-pack' && handle !== 'ring-nagon-som-bryr-sig-2-pack') return;

      const form = component.querySelector('form[action*="/cart/add"], form[data-type="add-to-cart-form"]');
      const buttons = component.querySelector('.product-form-buttons');
      if (!form || !buttons || buttons.querySelector('[data-rastboden-generated]')) return;

      generatedId += 1;
      const suffix = `${generatedId}`;
      const html = handle === 'valfri-text-2-pack' ? valfriTextMarkup(suffix) : contactMarkup(suffix);
      buttons.insertAdjacentHTML('afterbegin', html);

      const generated = buttons.querySelector('[data-rastboden-generated]');
      if (generated?.dataset.rastbodenGenerated === 'contact') bindContact(generated);
    });
  }

  function init() {
    bindOtherField('rastboden-flag-', 'rastboden-other-flag-');
    bindOtherField('rastboden-platform-', 'rastboden-other-platform-');
    injectNewPersonalization();
    document.querySelectorAll('[data-rastboden-generated="contact"]').forEach(bindContact);
  }

  function scheduleInit() {
    window.clearTimeout(observerTimer);
    observerTimer = window.setTimeout(init, 40);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init, { once: true });
  } else {
    init();
  }

  document.addEventListener('shopify:section:load', init);

  const observer = new MutationObserver(scheduleInit);
  observer.observe(document.documentElement, { childList: true, subtree: true });
})();
